export const IsCareProviderResponse = ({ value, record }) => record.isCareProviderResponse ? 'Mitt.' : 'Stn.'
